import { render, staticRenderFns } from "./DwOrder.vue?vue&type=template&id=03c89cdd&scoped=true"
import script from "./DwOrder.vue?vue&type=script&lang=js"
export * from "./DwOrder.vue?vue&type=script&lang=js"
import style0 from "./DwOrder.vue?vue&type=style&index=0&id=03c89cdd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c89cdd",
  null
  
)

export default component.exports